<span class="cursor" (click)="toggleState()">
  <ng-content></ng-content>
</span>
